<template>
  <AppLink :to="handleLink" v-if="IsMarketing">
    <div
      ref="button"
      class="sub-menu"
      :class="getClass()"
      @mouseover="handleOver"
      @mouseout="handleOut"
    >
      <div
        v-if="!isTitle || !isSpacer"
        class="sub-menu-marker"
      />
      <div class="sub-menu-content">
        <div class="sub-col">
          <div
            v-if="!isTitle"
            class="line"
          />
          <div class="sub-mid">
            <div
              v-if="isTitle"
              class="sub-menu-title"
            >
              {{ option.name }}
            </div>
            <div
              v-if="!isTitle && type !== 'sub-sub' && type !== 'no-icon'"
              class="sub-menu-icon"
            >
              <v-img
                :src="require('@/assets/svg/2x/icon_' + option.img + '.png')"
                class="app-icon"
              />
            </div>
            <div
              v-if="!isTitle"
              class="sub-menu-name"
            >
              {{ option.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </AppLink>
</template>

<script>
import AppLink from '@/components/nav/AppLink';
import { useIdentityStore } from '@/store/IdentityStore';
import { gsap } from 'gsap';

export default {
  name: 'SubMenuButton',
  components: {
    AppLink
  },
  props: [
      'option',
      'isTitle',
      'isSpacer',
      // layout type
      'type',
      // button content
      'content'
  ],
  computed: {
    IsMarketing () {
      if (useIdentityStore().User.subscriptions && useIdentityStore().User != null) {
        if (this.$props.option.name === 'Dealer Editor') {
          const subscriptions = useIdentityStore().User.subscriptions.map((item) => {
            return item.value;
          });
          if (subscriptions.includes('marketing')) {
            return true;
          }  else {
            return false;
          }
        } else {
           return true;
        }
      }
    },
    handleLink () {

      switch (this.$props.content) {

        case 'filter-option':
          return '/community/feed/' + this.$props.option.name.replaceAll(' ', '-').toLowerCase();
        case 'app':
        case 'internal':
          return this.$props.option.url;
        default:
          return '';
      }

    },

  },

  methods: {
    getClass () {
      if (this.$props.isTitle) {
        return 'white-bg';
      }
      switch (this.$props.type) {
        default:
        case 'sub-sub':
          return 'sub-sub';
      }
    },
    handleOver () {
      gsap.to(this.$refs.button, {
        backgroundColor: 'rgba(0, 189, 94, 0.07)'
      });
    },
    handleOut () {
      gsap.to(this.$refs.button, {
        backgroundColor: 'transparent'
      });
    }
  }
};
</script>

<style scoped>
a {
  color: transparent;
}
.sub-menu {
  color: #595a5a;
  height: var(--nav-height);
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.sub-sub {
  height: calc(var(--nav-height) * .75);
  background-color: var(--nelson-green10);
}
.white-bg {
  background-color: white;
}
.sub-menu-marker {
  height: 100%;
  width: 5px;
  background-color: var(--nelson-green);
}

.sub-col {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 100%;
  height: 100%;
}

.line {
  border-top: 1px solid var(--nelson-green50);
  width: 100%;
}

.sub-mid {

  padding-left: 15px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;


}

.sub-menu-icon {

  margin-right: 15px;
  width: 40px;
  height: 40px;
  background-color: white;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.15);

}

.sub-menu-title {

  font-weight: bolder;


}

.sub-menu-content {

  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

}

.sub-menu-name {

  font-size: .82em;
  letter-spacing: .02em;
  font-weight: bold;

}


.rl {
  width: inherit;
  height: inherit;
  background-color: #595a5a;
}

.app-icon {
  height: 40px;
}
</style>